class StateChangeController {
  /* @ngInject */
  constructor(StateChangeService, Session) {
    this.StateChangeService = StateChangeService;
    this.states = Session.read('states');
  }

  $onInit() {

  }
}

export default StateChangeController;



// WEBPACK FOOTER //
// ./client/components/state-change/state-change.controller.js